import { useContext, useEffect } from 'react'

import { CardContractProgramListener } from './ui'
import { 
    FieldsErrorType, ICardContractsProgramListener, 
    ICardContractProgramListenerContainer, IFieldsError 
} from './types'

import { useValue } from '@hooks/useValue'
import { validFormData } from '@hooks/useForm'
import { useFieldsErrorAnimation } from '@hooks/useFieldsErrorAnimation'

import { NotificationContext, notifyOpen } from '@ui/notification/notification.provider'


/** Редактирование свойств слушателя по договору - Контейнер */
export const CardContractProgramListenerContainer = ({
    isOpen, isAttestationTypeVisible, handlerButtonOk, handlerButtonCancel,
    attestationTypeID, attestationTypeName, qualification
}: ICardContractProgramListenerContainer) => {
    const notify = useContext(NotificationContext)

    const fieldsError = useValue<IFieldsError>({})

    const txtAttestationTypeID = useValue<number | ''>('')
    const txtAttestationType = useValue<string>('')

    const txtQualification = useValue<string>('')

    useEffect(() => {
        if (isOpen) {
            txtAttestationTypeID.setValue(attestationTypeID || '')
            txtAttestationType.setValue(attestationTypeName || '')
            txtQualification.setValue(qualification || '')
        }

        !isOpen && clearData()
    }, [isOpen]) // eslint-disable-line react-hooks/exhaustive-deps

    const clearData = () => {
        fieldsError.setValue({})

        txtAttestationTypeID.setValue('')
        txtAttestationType.setValue('')
        txtQualification.setValue('')
    }



    /** Кнопка сохранить все данные */
    const handleBtnSave = () => {
        const validateData = validFormData([ // Валидируем данные 
            {fieldName: 'attestationType', value: txtAttestationTypeID.value.toString(), validType: 'notEmpty', isRequired: true, errorMessage: 'Тип аттестации не выбрано.'},
            {fieldName: 'qualification', value: txtQualification.value, validType: 'notEmpty', isRequired: true, errorMessage: 'Квалификация не указана.'},
        ])

        for (const item of validateData) { // Выводим ошибки валидации
            fieldsErrorAnimation(item.fieldName as FieldsErrorType)
            notify && notifyOpen(item.message, 'warning', 2000, notify)
        }

        if (validateData.length === 0) { // Сохраняем данные
            handlerButtonOk && handlerButtonOk(Number(txtAttestationTypeID.value), txtQualification.value)
        }
    }
    /** Активация анимации ошибки в указанных полях */
    const fieldsErrorAnimation = useFieldsErrorAnimation<IFieldsError>(fieldsError.setValue)


    /** Свойства передаваемые в компоненту */
    const propsToComponent: ICardContractsProgramListener = {
        isOpen, isAttestationTypeVisible, 
        
        fieldsError, txtAttestationTypeID, txtAttestationType, txtQualification,
        handleBtnSave, handlerButtonCancel,
    }
    
    return <>
        <CardContractProgramListener {...propsToComponent} />
    </>
}